
import { getProductByID, toRollerShutter } from 'modules/shop-front/shop-front-component/ProductCollection'
import GenericProductPage from '../GenericProductPage'

export default function RS42mmSL() {

  return (
      GenericProductPage(getProductByID(61),toRollerShutter)
  )
}
